import React from "react";
import { catalogTableLabel } from "../../../app/helpers/helperCatalogs";

const ReadOnlyRow = ({ tableRecord, handleEditClick, handleDeleteClick }) => {

  return (
    <tr>
    <td className="td-tee">{catalogTableLabel(tableRecord && tableRecord.CatProblem_To_ModProblem)}</td>
      <td className="td-tee">{tableRecord.matter}</td>
      <td className="td-tee">{tableRecord.solution}</td>
      
      <td className="td-tee">
        <button
          className="table-button-edit"
          type="button"
          onClick={(event) => handleEditClick(event, tableRecord)}
        >
        <i className="fa fa-edit"></i>
        </button>
        <button type="button" className="table-button-delete" onClick={() => handleDeleteClick(tableRecord.id)}>
        <i className="fa fa-trash"></i>
        </button>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;
